<template>
<td v-if="!dataItem.inEdit" :class="className">{{ dataItem[field]}}</td>
    <td v-else><dropdownlist @change="change" :data-items='sifrantData' :text-field="'naziv'" :value="selectedValue" ></dropdownlist></td>
</template>
<script>
import { DropDownList } from '@progress/kendo-vue-dropdowns';


export default {
      components: {
  'drodownlist': DropDownList,

    },
    props: {

        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sifrantData:Array, 
        selectedValue:Object   },
    
    watch: {
    "dataItem": function (val) {
      console.log("Change of sifrant!!!")
      this.selectedValue={id:val.enotakolicineid,naziv:val.enota};
    }
    },

    methods: {
        change(e) {
             this.selectedValue={id:e.value.id,naziv:e.value.naziv};
             this.$emit('change', e, this.dataItem, e.value);
        }
    }
}
</script>